/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { ViewSwitcherComponent } from './view-switcher';
export * from './view-switcher-adapter';
export * from './view-switcher-constants';
export * from './view-switcher-core';
export * from './view-switcher';
export * from './view';
export function defineViewSwitcherComponent() {
    defineCustomElement(ViewSwitcherComponent);
}
